export enum LoggingPermissions {
  Maillog = 'maillog',
  Smslog = 'smslog',
  Updatelistlog = 'updatelistlog',
}